import { render, staticRenderFns } from "./sba-toggle-scope-button.vue?vue&type=template&id=03a6702e&scoped=true&"
import script from "./sba-toggle-scope-button.vue?vue&type=script&lang=js&"
export * from "./sba-toggle-scope-button.vue?vue&type=script&lang=js&"
import style0 from "./sba-toggle-scope-button.vue?vue&type=style&index=0&id=03a6702e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a6702e",
  null
  
)

export default component.exports